import { useState } from 'react';

import { DialogNugget, PanelNugget } from '@backrs_ui/common-ui';

import { handleBookmark } from '@backrs_ui/grow-ui/src/components/Nuggets/nugget.util';
import { LubavScholarship } from '@backrs_ui/grow-ui/src/models/models';
import { useAppDispatch, useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import { selectBookmarkedNuggetId } from '@backrs_ui/grow-ui/src/redux/user/user';

import { Box, Dialog } from '@mui/material';

import { commonStyles } from './CommonStyles';

const PROSPER_URL = process.env.REACT_APP_GROW_URL;

type ScholarshipsFormatterProps = Readonly<{
  scholarships: LubavScholarship[];
}>;

export const ScholarshipsFormatter = ({ scholarships }: ScholarshipsFormatterProps) => {
  const [open, setOpen] = useState(false);
  const [activeDialogNugget, setActiveDialogNugget] = useState<LubavScholarship | null>(null);

  const bookmarkId = useAppSelector(
    selectBookmarkedNuggetId({
      nuggetId: activeDialogNugget?.metadata.id,
      variant: 'scholarships',
    }),
  );

  const dispatch = useAppDispatch();

  const dialogNugget = activeDialogNugget ? (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md">
      <DialogNugget
        shareParams={
          PROSPER_URL
            ? {
                title: `Prosper: ${activeDialogNugget.metadata.name}`,
                text: `Prosper: ${activeDialogNugget.metadata?.description}`,
                url: `${PROSPER_URL}?scholarship=${activeDialogNugget.metadata.id}`, // UPDATE HERE
              }
            : undefined
        }
        title={activeDialogNugget?.metadata.name}
        titleOnClick={() => window.open(activeDialogNugget?.metadata.program_url, '_blank')}
        subTitle={activeDialogNugget?.metadata.donor?.split(':')[0]}
        variant={{
          type: 'scholarships',
          scholarshipInfo: activeDialogNugget?.metadata,
        }}
        description={''}
        columnCategory={activeDialogNugget?.metadata?.award_type}
        customMenuActions={[
          {
            icon: 'IconApply',
            text: 'Apply',
            onClick: () =>
              window.open(
                activeDialogNugget.metadata.submission_link ||
                  activeDialogNugget.metadata.program_url,
                '_blank',
              ),
          },
        ]}
        saveToLibrary={() =>
          handleBookmark({
            nuggetId: activeDialogNugget?.metadata.id,
            dispatch,
            bookmarkId,
            variant: 'internship',
          })
        }
        hasBookmarkedNugget={!!bookmarkId}
      />
    </Dialog>
  ) : null;

  return (
    <>
      {dialogNugget}
      <Box sx={commonStyles.nuggetList}>
        {scholarships.map((scholarship) => {
          return (
            <PanelNugget
              key={scholarship.id}
              title={scholarship.metadata.name}
              subText={scholarship.relevance}
              subTitle={scholarship.metadata.donor?.split(':')[0]}
              body={scholarship.metadata.description}
              size="SMALL"
              useSplitLayout={true}
              onClick={() => {
                setActiveDialogNugget(scholarship);
                setOpen(true);
              }}
              variant={{
                type: 'scholarships',
                scholarshipInfo: scholarship.metadata,
              }}
            />
          );
        })}
      </Box>
    </>
  );
};
